<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-10">
          <card shadow type="secondary">
            <div slot="header" class="border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">{{ $t("my_account") }}</h3>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent>
                <h6 class="heading-small text-muted mb-4">
                  {{ $t("user_information") }}
                </h6>
                <div class="">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        alternative=""
                        :label="$t('email')"
                        placeholder="jesse@example.com"
                        input-classes="form-control-alternative border"
                        v-model="model.email"
                        data-vv-validate-on="blur"
                        v-validate="'required'"
                        :data-vv-as="$t('email')"
                        name="email"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('email')"
                        ><small>{{ errors.first("email") }}</small></span
                      >
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        alternative=""
                        :label="$t('nickname')"
                        input-classes="form-control-alternative border"
                        v-model="model.nickname"
                        :placeholder="$t('nickname')"
                        data-vv-validate-on="blur"
                        v-validate="'required'"
                        :data-vv-as="$t('nickname')"
                        name="nickname"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('nickname')"
                        ><small>{{ errors.first("nickname") }}</small></span
                      >
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        alternative=""
                        :label="$t('name')"
                        input-classes="form-control-alternative border"
                        v-model="model.name"
                        :placeholder="$t('name')"
                        data-vv-validate-on="blur"
                        v-validate="'required'"
                        :data-vv-as="$t('name')"
                        name="name"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('name')"
                        ><small>{{ errors.first("name") }}</small></span
                      >
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        alternative=""
                        :label="$t('lastname')"
                        input-classes="form-control-alternative border"
                        v-model="model.lastname"
                        :placeholder="$t('lastname')"
                        data-vv-validate-on="blur"
                        v-validate="'required'"
                        :data-vv-as="$t('lastname')"
                        name="lastname"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('lastname')"
                        ><small>{{ errors.first("lastname") }}</small></span
                      >
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        alternative=""
                        :label="$t('wallet')"
                        input-classes="form-control-alternative border"
                        v-model="model.wallet"
                        :placeholder="$t('wallet')"
                        data-vv-validate-on="blur"
                        v-validate="''"
                        :data-vv-as="$t('wallet')"
                        name="wallet"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('wallet')"
                        ><small>{{ errors.first("wallet") }}</small></span
                      >
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <base-button
                      type="primary"
                      class="my-4"
                      @click="updateProfile"
                      >{{ $t("save") }}</base-button
                    >
                  </div>
                </div>
              </form>
            </template>
            <hr class="my-4" />
            <update-password />
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import updatePassword from "./UpdatePassword";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "user-profile",
  components: {
    updatePassword,
  },
  data() {
    return {
      model: {
        email: null,
        name: "",
        lastname: "",
        nickname: "",
        wallet: "",
      },
    };
  },

  async created() {
    this.model = {
      email: this.userData.email,
      name: this.userData.name,
      lastname: this.userData.lastname,
      nickname: this.userData.nickname,
      wallet: this.userData.wallet,
    };
  },
  methods: {
    ...mapActions({
      updateProfileUser: "auth/updateUser",
      updatePasswordUser: "auth/updatePassword",
    }),
    async updateProfile() {
      const validation = await this.$validator.validateAll();
      if (validation) {
        const res = await this.updateProfileUser(this.model);
        this.$toast.success(res.message, {
          position: "top-right",
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      userData: "user",
    }),
  },
};
</script>
<style></style>
